import api from '../api';
import type { LoginDTO, RegisterDTO, ResponseDTO } from '@/types';

export const userService = {
  async login(loginData: LoginDTO): Promise<ResponseDTO<string>> {
    const response = await api.post('/user/login', loginData);
    return response as unknown as ResponseDTO<string>;
  },
  
  async register(registerData: RegisterDTO): Promise<ResponseDTO<null>> {
    const response = await api.post('/user/register', registerData);
    return response as unknown as ResponseDTO<null>;
  },
  
  async getUserList(): Promise<ResponseDTO<any[]>> {
    const response = await api.get('/user/list');
    return response as unknown as ResponseDTO<any[]>;
  }
};